import { Action } from 'redux/reducers/interfaces'
import * as actions from 'redux/actions'
import { createReducer } from 'typesafe-actions'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initialState: any = {
    list: []
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const suppliersReducer = createReducer<any, Action>(initialState).handleAction(
    actions.getSuppliers.success,
    (state, action) => ({
        ...state,
        list: action.payload
    })
)
